import {
  LP_UNASSIGNED_SITE,
} from '../../card-definitions';

export const LINK_DEFAULTS = {
  page: 'dashboard',
};

export const name = '$hmPrintBeat';
export default function $hmPrintBeat(
  rnHttp,
  rnPreferences,
  moment,
  $window,
  $q,
) {
  'ngInject';

  const DATE_FORMAT = 'YYYY-MM-DD';

  const service = {
    createLink,
    redirect,
    queryLFPApi,
  };
  return service;

  function createLink(context) {
    let mergedContext = _.assign({}, LINK_DEFAULTS, context);

    let pbUrl = `/pb/#/redirect/${mergedContext.page}/${mergedContext.family}`;
    if (mergedContext.siteId === LP_UNASSIGNED_SITE) {
      // Use the Print Beat default of -1 for unassigned
      mergedContext.siteId = '-1';
    }

    if (mergedContext.siteId) {
      pbUrl += `/${mergedContext.siteId}`;
    }
    if (mergedContext.serialNumber) {
      pbUrl += `/${mergedContext.serialNumber}`;
    }
    return pbUrl;
  }

  function redirect(context, $event = {}) {
    let link = createLink(context);
    if ($event.ctrlKey) {
      $window.open(link, '_blank');
    } else {
      $window.location.href = link;
    }
  }

  function queryLFPApi(api, params) {
    return getUnitSystemPref().then(unitSystem => {
      let config = {
        params: Object.assign({
          isUTC: false,
          unitSystem,
        }, params)
      };

      if (moment.isMoment(config.params.from)) {
        config.params.from = config.params.from.format(DATE_FORMAT);
      }
      if (moment.isMoment(config.params.to)) {
        config.params.to = config.params.to.format(DATE_FORMAT);
      }

      // let allData = {};
      // let pages = Math.ceil(params.serial.length / 40);
      // let promises = [];
      // for (let p = 0; p < pages; p++) {
      //   let myConfig = {...config};
      //   myConfig.params.serial = params.serial.slice(p * 40, (p + 1) * 40);
      //   promises.push(rnHttp.get('PrintbeatService', `gsb/lfp/graphs/${api}`, myConfig).then(rnHttp.resolveWithData).then(resp => {
      //     console.log('queryLFPApi', resp);
      //     return resp;
      //   }));
      // }
      // return $q.all(promises).then(() => {
      //   return allData;
      // });
      let myConfig = {...config};
      // PrintBeatService apis have a limit of 50 devices, not sure how to get more and consolidate the data
      myConfig.params.serial = params.serial.slice(0, 50);
      return rnHttp.get('PrintbeatService', `gsb/lfp/graphs/${api}`, myConfig).then(rnHttp.resolveWithData);
    });
  }

  function getUnitSystemPref() {
    return rnPreferences.getAll().then(data => {
      return _.get(data, 'general.unitSystem', 'Metric');
    });
  }
}
